import { alwaysMoveToFocusedOtherService } from '../services/alwaysMoveToFocusedOtherService';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { getFocusedFilterForTable } from 'owa-mail-list-store';
import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
import { createOrUpdateFocusedOtherOverrideService } from 'owa-mail-triage-action/lib/services/createOrUpdateFocusedOtherOverrideService';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';
import datapoints from './datapoints';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import moveMailListRowsToFocusedOrOther from 'owa-mail-triage-action/lib/actions/move/moveMailListRowsToFocusedOrOther';
/**
 * Always move row from sender to focused/other action
 * @param rowKeys the rowws currently selected
 * @param tableView the table view
 * @param actionSource source of the action
 * @return the action response
 */
export default action('alwaysMoveRowToFocusedOrOtherInternal', datapoints.alwaysMoveRowToFocusedOrOtherDatapoint)(function alwaysMoveRowToFocusedOrOtherInternal(rowKeys, tableView, actionSource) {
    var senderSMTPAddress = MailRowDataPropertyGetter.getLastSenderSMTP(rowKeys[0], tableView);
    if (senderSMTPAddress == null) {
        return;
    }
    var inferenceClassification;
    var focusedFilter = getFocusedFilterForTable(tableView);
    switch (focusedFilter) {
        case 0 /* Focused */:
            inferenceClassification = 'Other';
            break;
        case 1 /* Other */:
            inferenceClassification = 'Focused';
            break;
        case -1 /* None */:
            throw new Error('FocusedViewFilter.None is not supported for this action');
    }
    // Show confirmation dialog
    confirm(null, format(strings.alwaysMoveConfirmationText, senderSMTPAddress, inferenceClassification)).then(function (response) {
        if (response === DialogResponse.ok) {
            // Since row may have been deleted from the table while the confirm dialog was open,
            // we need to validate the rows again before performing the operation.
            if (tableView.rowKeys.indexOf(rowKeys[0]) > -1) {
                // Only proceed if the selected row hasn't changed
                createOverrideAndSweepRow(rowKeys[0], senderSMTPAddress, inferenceClassification, tableView);
            }
        }
    });
});
/**
 * Create override and sweep row from sender to Focused/Other
 * @param rowKey to be acted upon
 * @param senderSMTPAddress the smtp address of the sender
 * @param inferenceClassification the new inference to set for this sender
 * @param tableView to which row belongs
 */
function createOverrideAndSweepRow(rowKey, senderSMTPAddress, inferenceClassification, tableView) {
    // Move row to Focused or Other
    moveMailListRowsToFocusedOrOther([rowKey], tableView.id, 'AlwaysMoveToFocusedOther');
    // Create override to move future rows from sender to Focused or Other
    createOrUpdateFocusedOtherOverrideService(senderSMTPAddress, inferenceClassification);
    // Sweep existing rows from the sender to target Focused or Other
    alwaysMoveToFocusedOtherService({
        Id: tableView.serverFolderId,
    }, [{ EmailAddress: senderSMTPAddress }], createSetItemField('InferenceClassification', inferenceClassification));
}
//# sourceMappingURL=alwaysMoveRowToFocusedOrOther.js.map